import { FC, useEffect, useState } from 'react'
import { firebaseAnalytics, firebaseController, googleAnalyticsController, mixpanelController, runProvider } from 'utils/analytics'

import { useLocation } from 'react-router-dom'

/** Logs pathnames to analytics */
const PathLogger: FC = () => {
  const location = useLocation()
  const [lastPath, setLastPath] = useState<string>()

  // Debounce last pathname
  useEffect(() => {
    const { pathname } = location
    if (lastPath !== pathname) setLastPath(pathname)
  }, [location, lastPath])

  // Analytics page tracking — contained per provider, an SDK throwing here would hit the error boundary (ISSUE-3098)
  useEffect(() => {
    if (!lastPath) return
    runProvider('firebase', 'screen_view', () => {
      if (firebaseController.analytics) {
        firebaseAnalytics.setCurrentScreen(firebaseController.analytics, lastPath)
        firebaseAnalytics.logEvent(firebaseController.analytics, 'screen_view', { firebase_screen: lastPath, firebase_screen_class: 'PathLogger', app_name: firebaseController.analytics?.app.name, screen_name: lastPath })
      }
    })
    runProvider('googleAnalytics', 'screen_view', () => {
      googleAnalyticsController.instance?.page()
      googleAnalyticsController.instance?.track('screen_view', { app_name: googleAnalyticsController.app_name, screen_name: lastPath })
    })
    runProvider('mixpanel', 'screen_view', () => mixpanelController.instance?.track('screen_view', { app_name: googleAnalyticsController.app_name, screen_name: lastPath }))
  }, [lastPath])

  return null
}

export default PathLogger
